import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store/index"; // 导入 Vuex store
import "./styles/font.css";
import "./styles/tokens.css";

const app = createApp(App);
app.use(router).use(store).mount("#app");
